<template>
  <div class="smart-recruiters-detail__section-one-container">
    <div
      v-for="item in sortedCustomFields"
      :key="item.order"
      class="smart-recruiters-detail__section-one-item"
    >
      <div
        :class="item.class"
        class="smart-recruiters-detail__section-one--card"
      >
        <div class="smart-recruiters-detail__section-one-content">
          <div class="smart-recruiters-detail__section-one-item-icon-wrapper">
            <icon-fi
              v-if="item.icon"
              :icon="item.icon"
              class="smart-recruiters-detail__section-one-item-icon"
            />
          </div>
          <div class="smart-recruiters-detail__section-one-item-text">
            <div class="smart-recruiters-detail__section-one-item-title">
              {{ item.title }}
            </div>
            <div>
              <div class="smart-recruiters-detail__section-one-item-label">
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';

defineOptions({ name: 'SmartRecruitersDetailSectionOne' });

withDefaults(
  defineProps<{
    sortedCustomFields?: any[];
  }>(),
  {
    sortedCustomFields: () => [],
  },
);
</script>

<style scoped src="./smart-recruiters-detail-section-one" />
